import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { fetchUserAfterSSO } from '../redux/authSlice';  // Adjust the import path as needed

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const loading = useSelector((state) => state.auth.loading);  // Optional: track loading state
  const [tokenChecked, setTokenChecked] = useState(false);

  useEffect(() => {
    // Check if the token is available
    const token = localStorage.getItem('authToken');
    if (!token) {
      console.error('No token found, redirecting to login...');
      setTokenChecked(true);  // Indicate token check is done, and redirect will happen
    } else {
      if (!user) {
        dispatch(fetchUserAfterSSO()).then(() => {
          setTokenChecked(true);  // Token found and user fetch initiated or completed
        });
      } else {
        setTokenChecked(true);  // User already exists in Redux state
      }
    }
  }, [dispatch, user]);

  // While the token or user is being loaded, show a loading screen or nothing
  if (!tokenChecked || loading) {
    return <div>Loading...</div>;
  }

  // If no user is found after checking and fetching, redirect to the login page
  if (!user && !loading) {
    return <Navigate to="/" />;
  }

  // If token is valid and user is found, render the children (protected content)
  return children;
};

export default ProtectedRoute;
